import Image from '@/components/image';
import ProductLabel from './ProductLabel';
import NextLink from '@/components/next-link';
import { select_item_event } from '@/utils/gtm';
import { labelPositions } from '@/constants/Pdp';
import AddToCart from '../../buttons/add-to-cart';
import ProductCardPrice from './product-card-price';
import ProductCardLabel from './product-card-label';
import AddToWishList from '../../buttons/add-to-wishlist';

const ProductCard = ({ product, isFromGrid, isFromWishList = false, ref }) => {
  const productName = Array.isArray(product?.name)
    ? product?.name?.[0]
    : product?.name;

  return (
    <div
      ref={ref}
      className={`${isFromGrid ? 'flex gap-2.5 sm:p-2' : 'lg:pb-3.5'} border-border group relative w-full overflow-hidden rounded-lg border`}
    >
      <div
        className={`relative cursor-pointer rounded-lg ${isFromGrid ? 'min-w-[172px] max-lg:min-w-35 max-sm:min-w-32' : 'lg:h-55.5'} bg-white`}
      >
        <NextLink
          className={`relative cursor-pointer ${isFromGrid ? '' : 'block max-lg:aspect-square max-lg:overflow-hidden'}`}
          href={`/product/${product?.rewrite_url}`?.replaceAll('.', '-')}
          onClick={() => select_item_event(product)}
        >
          <Image
            src={product?._media_?.image?.at(0)?.image}
            alt={productName}
            className={`${isFromGrid ? 'h-[172px] max-lg:h-35 max-sm:h-32' : 'lg:h-55.5'} size-full object-contain`}
          />
          <ProductLabel
            labels={product?.label}
            price={product?.prices_with_tax}
            imageType='default'
            containerHeight='220'
            labelPositions={labelPositions}
          />
        </NextLink>

        <div
          className={`absolute end-2 top-2 flex flex-col gap-2 max-sm:gap-1 ${!isFromWishList && 'md:hidden md:group-hover:block'} `}
        >
          <AddToWishList {...{ product, isFromWishList }} />
          <AddToCart {...{ isFromWishList, product, fromCartPopUp: false }} />
        </div>
      </div>
      <div className='max-md:p-2 lg:px-2.5 lg:py-1.5'>
        <p className='text-xs text-[#858585]'></p>
        <ProductCardLabel
          brand={product?.option_text_brands?.[0]}
          url={product?.rewrite_url}
          productName={productName}
          onClick={() => select_item_event(product)}
        />

        <ProductCardPrice
          price={product?.prices_with_tax}
          isFromGrid={isFromGrid}
        />
      </div>
    </div>
  );
};

export default ProductCard;
